module.exports = __webpack_public_path__ + "img/img_introduce.64e9d597.jpg";